import authorizationFailed from './authorizationFailed';
import authorizationSuccess from './authorizationSuccess';
import getUserDataFailed from './getUserDataFailed';
import requestAuthorization from './requestAuthorization';
import requestLogout from './requestLogout';
import requestLogoutSuccess from './requestLogoutSuccess';
import requestUserData from './requestUserData';
import userDataReceived from './userDataReceived';

export default {
    authorizationFailed,
    authorizationSuccess,
    getUserDataFailed,
    requestAuthorization,
    requestLogout,
    requestLogoutSuccess,
    requestUserData,
    userDataReceived,
};
